module.exports = __webpack_public_path__ + "img/pic32.0fed89f2.png";